import { render, staticRenderFns } from "./ViewEditbody.vue?vue&type=template&id=39b4d5e0&scoped=true&"
import script from "./ViewEditbody.vue?vue&type=script&lang=js&"
export * from "./ViewEditbody.vue?vue&type=script&lang=js&"
import style0 from "./ViewEditbody.vue?vue&type=style&index=0&id=39b4d5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4d5e0",
  null
  
)

export default component.exports